import React, { useState } from "react";
import axios from "axios";
import { Mail, Check } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "../lib/i18n";

const COPY = {
  el: {
    title: "Golden Elia Inner Circle",
    sub: "Αποκλειστικές προσφορές & limited edition συλλογές, πριν τις δει ο κόσμος.",
    placeholder: "Το email σας",
    button: "Εγγραφή",
    sending: "Αποστολή…",
    success: "Καλωσήρθατε στο Inner Circle.",
    error: "Κάτι πήγε στραβά. Δοκιμάστε ξανά.",
    invalid: "Δώστε ένα έγκυρο email.",
    done: "Είστε μέσα",
  },
  en: {
    title: "Golden Elia Inner Circle",
    sub: "Exclusive offers and limited-edition releases, before they go public.",
    placeholder: "Your email address",
    button: "Subscribe",
    sending: "Sending…",
    success: "Welcome to the Inner Circle.",
    error: "Something went wrong. Try again.",
    invalid: "Please enter a valid email.",
    done: "You're in",
  },
  bg: {
    title: "Golden Elia Inner Circle",
    sub: "Ексклузивни оферти и limited edition колекции, преди да станат публични.",
    placeholder: "Вашият имейл",
    button: "Абонирай",
    sending: "Изпращане…",
    success: "Добре дошли в Inner Circle.",
    error: "Нещо се обърка. Опитайте отново.",
    invalid: "Моля въведете валиден имейл.",
    done: "Готово",
  },
  ru: {
    title: "Golden Elia Inner Circle",
    sub: "Эксклюзивные предложения и limited edition, раньше других.",
    placeholder: "Ваш email",
    button: "Подписаться",
    sending: "Отправка…",
    success: "Добро пожаловать в Inner Circle.",
    error: "Что-то пошло не так. Попробуйте снова.",
    invalid: "Укажите корректный email.",
    done: "Готово",
  },
};

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const Newsletter = () => {
  const { lang } = useLang();
  const t = COPY[lang] || COPY.el;
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle"); // idle | sending | done

  const submit = async (e) => {
    e.preventDefault();
    const value = email.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      toast.error(t.invalid);
      return;
    }
    setState("sending");
    try {
      await axios.post(`${API}/newsletter`, { email: value, lang });
      setState("done");
      toast.success(t.success);
    } catch (err) {
      setState("idle");
      toast.error(t.error);
    }
  };

  return (
    <div
      data-testid="newsletter"
      className="w-full max-w-xl mx-auto text-center px-4 py-8 border border-[color:var(--goldenelia-gold)]/25 bg-black/60"
    >
      <p className="font-display text-[11px] tracking-[0.45em] text-[color:var(--goldenelia-gold)] uppercase mb-2">
        {t.title}
      </p>
      <p className="font-serif-luxury italic text-sm sm:text-base text-[color:var(--goldenelia-cream)]/80 mb-5 max-w-md mx-auto">
        {t.sub}
      </p>

      {state === "done" ? (
        <div
          data-testid="newsletter-done"
          className="inline-flex items-center gap-2 text-[color:var(--goldenelia-gold-bright)] font-display text-xs tracking-[0.3em] uppercase"
        >
          <Check size={16} /> {t.done}
        </div>
      ) : (
        <form
          onSubmit={submit}
          className="flex flex-col sm:flex-row gap-3 items-stretch max-w-md mx-auto"
        >
          <div className="relative flex-1">
            <Mail
              size={16}
              className="absolute left-3 top-1/2 -translate-y-1/2 text-[color:var(--goldenelia-gold)]/70"
            />
            <input
              data-testid="newsletter-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder={t.placeholder}
              className="w-full pl-10 pr-4 py-3 bg-transparent border border-[color:var(--goldenelia-gold)]/35 text-[color:var(--goldenelia-cream)] placeholder:text-[color:var(--goldenelia-cream)]/40 font-body text-sm focus:outline-none focus:border-[color:var(--goldenelia-gold)] transition-colors"
            />
          </div>
          <button
            data-testid="newsletter-submit"
            disabled={state === "sending"}
            type="submit"
            className="btn-ghost-gold !py-3 !px-6 text-[11px] disabled:opacity-60"
          >
            {state === "sending" ? t.sending : t.button}
          </button>
        </form>
      )}
    </div>
  );
};

export default Newsletter;
